import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { pickThemeFontStyles } from '@/theme';

export const StyledLinkButton = styled(Link)`
  ${pickThemeFontStyles('14', '18', 'BOLD')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 1.5rem;
  height: ${({ theme }) => `${theme.token?.controlHeight}px`};
  border-radius: ${({ theme }) => `${theme.token?.borderRadius}px`};
  background-color: ${({ theme }) => theme.token?.colorPrimary};
  color: ${({ theme }) => theme.token?.colorPrimaryText};

  &&& {
    text-decoration: none;
  }

  &:hover {
    background-color: ${({ theme }) => theme.token?.colorPrimaryHover};
    color: ${({ theme }) => theme.token?.colorPrimaryText};
  }
`;
